/**
 *  分模块翻译，方便维护
 *  lang/zh-cn/module/login.js
 */

export default {
  "login": {
    "log_in": "登录",
    "register": "注册",
    "mobile_log_in": "手机登录",
    "psd_log_in": "密码登录",
    "wx_log_in": "微信登录",
    "sms_log_in": "短信登录",
    "phone_number": "手机号",
    "verification_code": "验证码",
    "get_verification_code": "获取验证码",
    "account": "手机/邮箱/用户名",
    "email": "邮箱",
    "user_name": "用户名",
    "password": "密码",
    "Logging_in": "登录中",
    "remember_me": "自动登录",
    "forget_password": "忘记密码",
    "social_account_login": "社交账号登录",
    "register_now": "立即注册",
    "link": "绑定",
    "link_account": "账号绑定",
    "intermediate_page": "登录中间页",
  }
};